import React from 'react';
import { NavLinkText } from '../../styles';

interface OptionalNavLabelProps {
  label: string;
  route?: string;
}

export function OptionalNavLabel({ label, route }: OptionalNavLabelProps) {
  if (route) {
    return <NavLinkText to={route}>{label}</NavLinkText>;
  }

  return <span>{label}</span>;
}
